module.exports = __webpack_public_path__ + "static/media/get_code_1@2x.95598fc3.png";